import { FavouriteOrderAvailability } from '../../enums/favourite-order-availability.enum';
import { OrderDetails } from './order-details.model';

export class FavoriteOrderDetails extends OrderDetails {
    createdOn?: string;
    isShared?: boolean;
    availability?: FavouriteOrderAvailability;
    createdBy?: string;
    canBeDeleted: boolean;
    code: string;
    constructor() {
        super();
    }
}
